import { useMemo } from 'react'
import { Button, HStack, VStack } from '@chakra-ui/react'
import NavBar from 'components/NavBar'
import { useSelector } from 'model/hooks'
import { IEntityType, NodeDataT } from 'shared/types'
import { AddIcon } from '@chakra-ui/icons'
import { useNavigate } from 'react-router-dom'
import { dbCreateLibraryCourse } from 'controllers/library'
import _ from 'lodash'
import { NodeModel } from '@minoru/react-dnd-treeview'
import { dbUpdateFileTree } from 'controllers/fileThree'
import FileThree from 'components/FileThree'

const Library = () => {
  const navigate = useNavigate()
  const courses = useSelector(state => state.library)
  const fileThreeDBData = useSelector(state => state.fileTree)

  const treeData = useMemo(() => {
    const dbTreeRaw = _.get(fileThreeDBData, IEntityType.LIBRARY, [])
    const dbTree = _.map(dbTreeRaw, el => {
      if (el.data && el.data.id) {
        const c = _.get(courses, el.data.id)
        if (c) {
          return { ...el, text: _.get(c, 'title', 'unnamed') }
        } else {
          return null
        }
      } else {
        return el
      }
    })
    const res = _.compact(dbTree)
    const dbTreeDict = _.keyBy(dbTree, 'id')
    _.forEach(courses, c => {
      if (!_.has(dbTreeDict, c.id)) {
        const n: NodeModel<NodeDataT> = {
          id: c.id,
          parent: 'root',
          text: c.title,
          droppable: false,
          data: {
            id: c.id
          }
        }
        res.push(n)
      }
    })
    return res
  }, [fileThreeDBData, courses])

  const onChangeFileTree = (treeData: NodeModel<NodeDataT>[]) => {
    dbUpdateFileTree(IEntityType.LIBRARY, treeData)
  }

  const onCreateCourseClick = async () => {
    const courseId = await dbCreateLibraryCourse()
    navigate(`/library/${courseId}`)
  }

  const navBarActions = (
    <HStack>
      <Button
        colorScheme='teal'
        leftIcon={<AddIcon />}
        onClick={onCreateCourseClick}
      >
        Создать курс
      </Button>
    </HStack>
  )

  return (
    <VStack w='full' h='full' spacing={0}>
      <NavBar hideBackButton title='Библиотека'>
        {navBarActions}
      </NavBar>
      <VStack align={'center'} w='full' h='full' p={4} overflowY={'auto'}>
        <VStack maxW='4xl' w='full'>
          <FileThree
            treeData={treeData}
            onChange={onChangeFileTree}
            onNodeClick={id => navigate(`/${IEntityType.LIBRARY}/${id}`)}
          />
        </VStack>
      </VStack>
    </VStack>
  )
}

export default Library
